<template>

  <div class="" style="overflow: auto;">
    <!--<div class="uk-overlay uk-overlay-primary ">
      <p>Default Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
    </div>-->
    <div class="uk-background-muted sticky-component uk-visible@m" style="/*border-top-color: #ffcb05; border-top-style: solid*/">
      <!--<div class="uk-card uk-card-default uk-text-center resultCard" style="">
        <div v-for="(sportsDetail, index) in sportsDetails" :key="index" class="">
           {{sportsDetail}}
         </div>
         <div class="uk-grid-divider uk-child-width-expand@s sportsGrid"  uk-grid >
          <div v-for="(sportsDetail, index) in sportsDetails" :key="index" class="" >
            <div style="float: left;">
              <img id="crestImg" :src="sportsDetail.crest" width="75"/>
            </div>
            <div class="pointsDiv" style="float: right; margin-top: 8px; font-size: 40px; ">
              <span class="points"> {{sportsDetail.points}}</span>
              <br/>
            </div>
            <br/>
          </div>

        </div>

      </div>-->
      <a class=" float" href="#modal-container" uk-toggle>
        <p class="uk-text-bold my-float">Sports Result</p>
      </a>

      <div id="modal-container" class="uk-modal-container" uk-modal>
        <div class="uk-modal-dialog uk-modal-body">
          <button class="uk-modal-close-default" type="button" uk-close></button>
          <h2 class="uk-modal-title uk-text-bold uk-heading-bullet uk-text-center">Sport's Day Results</h2>
          <br/>
          <div>
            <ul class="uk-list uk-list-collapse uk-list-divider" >
              <li v-for="(sportsDetail1, index) in sportsDetails" :key="index">
                <div style="float: left;">
                  <img :src="sportsDetail1.crest" width="90"/>
                </div>
                <div  style="float: right; font-size: 25px; font-weight: bold;">
                  <span id="points">Points: {{sportsDetail1.points}}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </div>
    <div class="uk-hidden@m">
      <a class=" float" href="#modal-container" uk-toggle>
        <p class="uk-text-bold my-float">Sports Result</p>
      </a>

      <div id="modal-container" class="uk-modal-container" uk-modal>
        <div class="uk-modal-dialog uk-modal-body">
          <button class="uk-modal-close-default" type="button" uk-close></button>
          <h2 class="uk-modal-title uk-text-bold uk-heading-bullet uk-text-center">Sport's Day Results</h2>
            <br/>
          <div>
            <ul class="uk-list uk-list-collapse uk-list-divider" >
              <li v-for="(sportsDetail1, index) in sportsDetails" :key="index">
                <div style="float: left;">
                  <img :src="sportsDetail1.crest" width="90"/>
                </div>
                <div  style="float: right; font-size: 25px; font-weight: bold;">
                  <span id="points">Points: {{sportsDetail1.points}}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>



  </div>

</template>

<script>
import axios from "axios";

export default {
  name: "sportsDayResults",
  data() {
    return {
        sportsDetails:[]
    }
  },
  sportsDetails: function (n, o){
    console.log(n)
    console.log(o)
  },
  mounted() {
    axios.get("https://sports.ncu.edu.jm/house-tally-results-data?token=87d080a7227aa5bdac616b3cd784517f")
        .then(res =>{
          //this.sportsDetails = res.data
          for(let i in res.data.data.order){
            this.sportsDetails.push({
              name:i,
              crest:res.data.data.tally[i].crest,
              points:res.data.data.order[i]
            });
          }

    });
  }
}
</script>

<style scoped>
.sticky-component {
  position:fixed;
  bottom: 0;
  width: 100%;
  z-index: 100;
}

@media only screen and (min-width : 2560px) {
.sportsGrid{
  padding-top: 7px;
  padding-bottom: 7px;
  margin-right: 350px;
  margin-left: 350px;
}
  .resultCard{
    margin-right: 900px;
    margin-left: 900px;
  }
  .float{
    position:fixed;
    width:200px;
    height:65px;
    bottom: 10px;
    left:35px;
    background-color: #033860;
    color: white;
    border-radius:100px;
    text-align:center;
    box-shadow: 2px 2px 3px black;
    margin-right: 5px;
    margin-bottom: 6px;
    font-size: 14px;
    font-weight: bold;
    z-index: 100;
  }
  .my-float{
    margin-top:12px;
  }
}
@media only screen and (min-width : 1440px){
  .sportsGrid {
    padding-top: 7px;
    padding-bottom: 7px;


  }

  .resultCard{
    margin-right: 530px;
    margin-left: 230px;
  }

}
@media only screen and (min-width : 1024px) {
  .sportsGrid {
    padding-top: 2px;
    padding-bottom: 2px;
    margin-right: 180px;
    margin-left: 180px;
  }
  .points{
    margin-right: 30px;
    margin-left: 30px;
    font-size: 70px;
  }
  .resultCard{
    margin-right: 130px;
    margin-left: 6px;
  }
}
@media only screen and (min-width : 768px) {
  .sportsGrid{
    margin-right: 20px;
    margin-left: 10px;
  }
  #crestImg{
    width: 60px;
    margin-top: 10px;
  }
  .points{
      font-size: 20px;
   }

  .float{
    position:fixed;
    width:100px;
    height:65px;
    bottom: 10px;
    left:35px;
    background-color: #033860;
    color: white;
    border-radius:50px;
    text-align:center;
    box-shadow: 2px 2px 3px black;
    margin-right: 5px;
    margin-bottom: 6px;
    font-size: 14px;
    font-weight: bold;
    z-index: 100;
  }
  .my-float{
    margin-top:12px;
  }
}

@media only screen and (min-width : 320px) {
  .float{
    position:fixed;
    width:65px;
    height:65px;
    bottom: 15px;
    left:35px;
    background-color: #033860;
    color: white;
    border-radius:50px;
    text-align:center;
    box-shadow: 2px 2px 3px black;
    margin-right: 5px;
    margin-bottom: 6px;
    font-size: 14px;
    font-weight: bold;
    z-index: 100;
  }
  .my-float{
    margin-top:12px;
  }
}


@media only screen and (min-width : 480px) {
  .float{
    position:fixed;
    width:75px;
    height:75px;
    bottom: 15px;
    left:35px;
    background-color: #033860;
    color: white;
    border-radius:50px;
    text-align:center;
    box-shadow: 2px 2px 3px black;
    margin-right: 5px;
    margin-bottom: 6px;
    font-size: 17px;
    font-weight: bold;
    z-index: 100;
  }
  .my-float{
    margin-top:12px;
  }
}
</style>